/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The attendee's response status to the event invitation. Defaults to 'needsAction' if the calendar platform did not provide response status information. Possible values: 'accepted' (attendee accepted the invitation), 'declined' (attendee declined the invitation), 'tentative' (attendee responded as tentative), 'needsAction' (attendee has not responded yet)
 */
export type GetEventDetailsResponseInputDataAttendeesAnyOfItemResponseStatus =
  (typeof GetEventDetailsResponseInputDataAttendeesAnyOfItemResponseStatus)[keyof typeof GetEventDetailsResponseInputDataAttendeesAnyOfItemResponseStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventDetailsResponseInputDataAttendeesAnyOfItemResponseStatus = {
  accepted: "accepted",
  declined: "declined",
  tentative: "tentative",
  needsAction: "needsAction"
} as const
